import { jsx } from "panel";
import { ModalEl } from "common/components/modal";
import { BannerEl } from "common/components/banner";
import { InputEl } from "common/components/input";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { BannerType } from "common/components/banner/types";
import { formatText } from "common/util/format-text";
import { MarkdownEl } from "../markdown";
export function template() {
  const {
    t,
    print
  } = this.getContext(`i18n`);
  const {
    inputError,
    inputValue
  } = this.state;
  const description = this.params.description ? print(this.params.description) : this.attr(`description`);
  const proxyAttrs = {};
  [`closeable`, `open`, `grow-to-content`, `not-fullscreen`, `modal-type`].forEach((attr) => proxyAttrs[attr] = this.attr(attr));
  const title = this.params.title ? print(this.params.title) : this.attr(`title`);
  return /* @__PURE__ */ jsx(ModalEl, { attrs: proxyAttrs, on: {
    change: this.helpers.modalChanged
  }, "data-sentry-element": "ModalEl", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".mp-confirm-container" }, /* @__PURE__ */ jsx("div", { sel: ".mp-confirm-body" }, /* @__PURE__ */ jsx("div", { sel: ".mp-confirm-body-content" }, /* @__PURE__ */ jsx(null, null, this.attr(`banner-text`) ? /* @__PURE__ */ jsx(BannerEl, { sel: ".mp-confirm-info-banner", theme: `info`, type: BannerType.Embedded, bodyText: this.attr(`banner-text`) }) : null, title ? /* @__PURE__ */ jsx("div", { sel: ".mp-confirm-title" }, title) : null, description ? this.attr(`description-allow-newline`) ? /* @__PURE__ */ jsx("div", { sel: ".mp-confirm-description-newline" }, formatText(description, {
    className: `confirm-description-newline`
  })) : this.attr(`description-use-markdown`) ? /* @__PURE__ */ jsx("div", { sel: ".mp-confirm-description-newline" }, /* @__PURE__ */ jsx(MarkdownEl, { attrs: {
    text: description
  } })) : /* @__PURE__ */ jsx("div", { sel: ".mp-confirm-description" }, description) : null, this.attr(`show-input`) ? /* @__PURE__ */ jsx(InputEl, { attrs: {
    elref: `confirmInput`
  }, sel: ".mp-confirm-input", params: {
    autoFocus: true,
    errorMessage: inputError,
    validationStatus: inputError ? `invalid` : ``,
    onInput: this.helpers.changeInputValue,
    onKeyup: this.helpers.commitInputValue
  }, props: {
    value: inputValue
  } }) : null, this.attr(`bottom-banner-text`) ? /* @__PURE__ */ jsx(BannerEl, { sel: ".mp-confirm-info-banner-bottom", theme: `info`, type: BannerType.Embedded, bodyText: this.attr(`bottom-banner-text`) }) : null, this.bannerContent || /* @__PURE__ */ jsx("slot", null)))), /* @__PURE__ */ jsx("div", { sel: ".mp-confirm-buttons" }, !this.attr(`hide-cancel-button`) ? this.attr(`theme`) !== `info` ? /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    theme: ButtonTheme.Tertiary,
    elref: `mpConfirmCancelButton`
  }, class: {
    "mp-confirm-button-cancel": true
  }, on: {
    click: this.helpers.cancel
  } }, this.attr(`cancel-button-label`) || t(`common.cancel`)) : null : null, /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    elref: `mpConfirmConfirmButton`,
    disabled: this.helpers.isConfirmButtonDisabled(),
    theme: ButtonTheme.Primary,
    type: this.attr(`theme`) === `delete` ? this.helpers.ButtonType.Destructive : this.helpers.ButtonType.Info
  }, class: {
    "mp-confirm-button-accept": true
  }, on: {
    click: this.helpers.confirm
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, this.params.confirmButtonLabel ? print(this.params.confirmButtonLabel) : this.attr(`confirm-button-label`) ? this.attr(`confirm-button-label`) : this.attr(`theme`) === `delete` ? t(`common.delete`) : `Okay`))));
}
